import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentTypePage = {
  alert: {
    error: 'coapplicant-employment-type-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-type-page.footer.root',
  },
  form: {
    h1: 'coapplicant-employment-type-page.form.h1',
    h2: 'coapplicant-employment-type-page.form.h2',
    radioGroupRoot: 'coapplicant-employment-type-page.form.radio-group-root',
    radioOption1: 'coapplicant-employment-type-page.form.radio-option-1',
    radioOption2: 'coapplicant-employment-type-page.form.radio-option-2',
    radioOption3: 'coapplicant-employment-type-page.form.radio-option-3',
    radioOption4: 'coapplicant-employment-type-page.form.radio-option-4',
    root: 'coapplicant-employment-type-page.form.root',
    submitButton: 'coapplicant-employment-type-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-employment-type-page.header.drawer-button',
    previousStepButton:
      'coapplicant-employment-type-page.header.previous-step-button',
    root: 'coapplicant-employment-type-page.header.root',
  },
  progress: {
    root: 'coapplicant-employment-type-page.progress.root',
  },
} as const satisfies PageLocatorMap;
